/** @format */

export const DELIVERY_TYPE_LEGENDS = {
	default: {
		delivery: {
			heading: 'Los envíos a domicilio',
			bullets: [
				'Comunas de Santiago se entregan entre las 17:00 y 22:00 hrs.',
				'Regiones (incluida la Metropolitana) Los realiza Correos de Chile entre 24 y 48 horas. En caso de que no llegue a tu domicilio, nos contactaremos para indicar la sucursal de retiro.',
			],
		},
		pharmacy: {
			heading: 'Los retiros en farmacia',
			bullets: ['Se realizan de lunes a viernes de 9:30 a 18:00 hs.'],
		},
	},
	CLANICX: {
		delivery: {
			heading: 'Los envíos a domicilio',
			bullets: [
				'Se realizan en el día, siempre que la compra se realice antes de las 14hs de lunes a viernes, después de ese horario se entregará en el siguiente día hábil.',
			],
		},
		pharmacy: {
			heading: 'Los retiros en farmacia',
			bullets: ['Se realizan de lunes a viernes de 9:30 a 18:00 hs o sábados hasta las 14 hs.'],
		},
	},
	CLZUPHARMA: {
		delivery: {
			heading: 'Los envíos a domicilio',
			bullets: [
				'Se realizan de lunes a sábados de 12:00 a 21:00 hs.',
				'Se realizan en el día, siempre que la compra se realice antes de las 15:00 hs de lunes a viernes o sábados hasta las 13:00 hs, después de ese horario se entregará en el siguiente día hábil.',
			],
		},
		pharmacy: {
			heading: 'Los retiros en farmacia',
			bullets: [
				'Se realizan de lunes a sábado de 15:00 a 20:00 hs.',
				'Se realizan en el día, siempre que la compra se realice antes de las 15:00 hs de lunes a viernes o sábados hasta las 13:00 hs, después de ese horario se entregará en el siguiente día hábil.',
			],
		},
	},
};

export const getDeliveryTypeLegend = (country, deliveryType) => {
	const byCountry = DELIVERY_TYPE_LEGENDS[country] || DELIVERY_TYPE_LEGENDS.default;
	return byCountry[deliveryType] || DELIVERY_TYPE_LEGENDS.default[deliveryType];
};
